import React, { useState, useEffect } from 'react';
import { GrCertificate } from 'react-icons/gr';
import { MdOutlineUpdate } from 'react-icons/md';
import ReferenceCopy from '../reference-copy';

import './index.css';

const patents = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/publications/patents.json`;

    const [content, setContent] = useState([]);

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div id="Patents" className="patents">
            <h3>Patents</h3>
            <ol>
                {content.map((item, index) => {
                    return (
                        <li key={index}>
                            <p>
                                <a className="patent-title" target="blank" href={item.link}>
                                    {item.title}
                                </a>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <ReferenceCopy data={item} type="patent" />
                            </p>
                            <span className="patent-author">
                                <i className="fas fa-user-friends" />
                                &nbsp;
                                {item.authors.map((author, authorIndex, arr) => {
                                    if (authorIndex === 0) return author;
                                    if (authorIndex === arr.length - 1) return ` & ${author}`;
                                    return `, ${author}`;
                                })}
                            </span>
                            <br />
                            <span className="patent-name">
                                <GrCertificate />
                                &nbsp;&nbsp;&nbsp;Application No.: {item.application.number}
                                &nbsp;&nbsp;&nbsp;Dated: {item.application.date}
                            </span>
                            <br />
                            <span className="patent-location">
                                <i className="fas fa-map-marker-alt" />
                                &nbsp;&nbsp;&nbsp; Agency / Country: {item.location}
                            </span>
                            <br />
                            <span className="patent-status">
                                <MdOutlineUpdate />
                                &nbsp;&nbsp; Current Status: {item.status.message}&nbsp;
                                {item.status.date && item.status.date.length > 0 ? (
                                    <span>({item.status.date})</span>
                                ) : (
                                    ''
                                )}
                            </span>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default patents;
